import type { DragEndEvent } from '@dnd-kit/core';
import type { ReportOrderPlacement } from './moveOrderedItem';

export interface ReportOrderMove {
    sourceId: string;
    targetId: string;
    placement: ReportOrderPlacement;
}

export function resolveDragEndMove(
    { active, over }: DragEndEvent,
    itemIds: string[],
): ReportOrderMove | undefined {
    if (!over || active.id === over.id) {
        return undefined;
    }
    const sourceId = String(active.id);
    const targetId = String(over.id);
    const sourcePosition = itemIds.indexOf(sourceId);
    const targetPosition = itemIds.indexOf(targetId);
    if (sourcePosition < 0 || targetPosition < 0) {
        return undefined;
    }
    return {
        sourceId,
        targetId,
        placement: sourcePosition < targetPosition ? 'after' : 'before',
    };
}
